export default __webpack_public_path__ + "static/eNFAWAak-b8023587fddd390b9980b49565ed4ac2.svg";